window.$ = window.jQuery = require("jquery");
require("jquery-form");
require("inputmask/dist/jquery.inputmask.min");

window.bootstrap = require("bootstrap");
window.Sortable = require("sortablejs").default;
require("devbridge-autocomplete");
window.Cropper = require("cropperjs");
require("@fancyapps/fancybox/dist/jquery.fancybox.min");

// Select2: плагин к jQuery + ru-локализация («Ничего не найдено» и т.п.);
// инициализация селектов .select2 — в ./dashboard/select2 (window.initAdminSelects).
require("select2");
require("select2/dist/js/i18n/ru");

require("./utils/ajax-headers");
require("./utils/ajax-form");
require("./utils/inputmask");
require("./utils/yandex-links");
require("./utils/yandex-links.info");
require("./utils/local-time");

// TinyMCE: ядро, иконки, модель, тема и плагины идут в бандле — редактор ничего не запрашивает с /tinymce/*.
// require("tinymce") сам выставляет window.tinymce (module.exports под webpack недоступен — это штатное поведение пакета).
require("tinymce");
require("tinymce/icons/default");
require("tinymce/models/dom");
require("tinymce/themes/silver");
require("tinymce/plugins/code");
require("tinymce/plugins/charmap");
require("tinymce/plugins/image");
require("tinymce/plugins/link");
require("tinymce/plugins/lists");
require("tinymce/plugins/table");
require("tinymce/plugins/wordcount");
require("./dashboard/tinymce-langs/ru"); // ru-локализация: в npm-пакете v8 каталога langs нет

require("./dashboard/tinymce");
require("./dashboard/tinymce-file-manager");
require("./utils/preset-select-fill");
require("./dashboard/select2"); // Select2 для селектов .select2 (одиночные и multiple)
require("./dashboard/modals");
require("./dashboard/data-method-url");
require("./dashboard/open-modal-window"); // базовый слой: создание окна «на лету» + реестр обработчиков кнопок
require("./dashboard/open-modal-url");    // url-слой: окно с контентом по ссылке (крутилка до показа, GET после)
require("./dashboard/open-modal-form");   // форменный слой: кнопки футера и AJAX отправка формы
require("./dashboard/toast");
require("./dashboard/table-delete");
require("./dashboard/table-dnd"); // Пересортировка строк админских таблиц (TableDnD, flat/tree, блок с потомками)
require("./dashboard/file-dropzone");
require("./dashboard/cropper-window");
require("./dashboard/image-upload");

